<div class="header-bloc">
    <div class="row head" *ngIf="isAdmin">
        <div class="container col-12 d-flex justify-content-between">
            <div class="col-6 d-flex justify-content-start">
                <img src="src-adisco/assets/images/logo-adisco.png" alt="" width="80" height="60">
            </div>
            <div class="col-6 d-flex justify-content-end align-items-center">
                <a class="px-3" *ngIf="isAdmin" routerLink="/admin/view-121">{{'Retour page admin'}}</a>
                <a class="px-3 disconnect" *ngIf="isAdmin" routerLink="/logout">{{'Déconnexion'}}</a>
            </div>
        </div>
    </div>
    <div class="row navbar" *ngIf="isAdmin">
        <div class="container d-flex text-center justify-content-center">
            <a *ngIf="isAdmin" routerLink="/import" routerLinkActive="active">{{'Import de trames'|uppercase}}</a>
            <a *ngIf="isAdmin" routerLink="/validation" routerLinkActive="active">{{'Validation de trames'|uppercase}}</a>
        </div>
    </div>
</div>